import React from "react"
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'
import { CustomInput, Button } from 'reactstrap'
import DatePicker from 'react-datepicker'
import SearchIcon from "../../../static/images/search_icon.svg"
import { leave_status, FONTS, COLORS } from '../../../constants'

/* eslint no-underscore-dangle: 0 */
export default class SearchBarLeaveHistory extends React.Component {
  state={ tempSearch: '' }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.tempSearch === this.state.tempSearch
      && get(nextProps, 'start_date') === get(this.props, 'start_date')
      && get(nextProps, 'end_date') === get(this.props, 'end_dae')
      && get(nextProps, 'selectedCompany') === get(this.props, 'selectedCompany')
      && get(nextProps, 'selectedLOB') === get(this.props, 'selectedLOB')
      && get(nextProps, 'selectedLeaveType') === get(this.props, 'selectedLeaveType')
      && get(nextProps, 'selectedStatus') === get(this.props, 'selectedStatus')
    ) return false
    return true
  }

  render() {
    return (
      <Wrapper>
        <WrapperButton>
          <Col>
            <SearchField
              placeholder='Search'
              value={ this.state.tempSearch }
              onChange={ (e) => {
                if (e.target.value === '') {
                  this.props.handleInputLeaveHistory('search', e.target.value)
                }
                this.setState({ tempSearch: e.target.value })
              } }
              onKeyDown={ (e) => {
                if (e.keyCode === 13) {
                  this.props.handleInputLeaveHistory('search', this.state.tempSearch)
                }
              } }
            />
          </Col>
          <Col>
            <Text>Start Date:</Text>
            <YOSDatePicker
              autoComplete='off'
              onChange={ this.props.handleChangeStartDate }
              name="start_date"
              placeholderText='DD/MM/YYYY'
              selected={ get(this.props, 'start_date') }
              dateFormat="DD/MM/YYYY"
              showYearDropdown
              showMonthDropdown
              minDate={
                get(this.props, 'start_date') === null ?
                  moment(get(this.props, 'end_date'))
                    .subtract(90, 'days')
                    .utcOffset(0)
                    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }) : null
              }
            />
          </Col>
          <Col>
            <Text>End Date:</Text>
            <YOSDatePicker
              autoComplete='off'
              onChange={ this.props.handleChangeEndDate }
              name="end_date"
              placeholderText='DD/MM/YYYY'
              selected={ get(this.props, 'end_date') }
              dateFormat="DD/MM/YYYY"
              showYearDropdown
              showMonthDropdown
              maxDate={
                get(this.props, 'end_date') === null ?
                  moment(get(this.props, 'start_date'))
                    .add(90, 'days')
                    .utcOffset(0)
                    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }) : null
              }
            />
          </Col>
          <Col>
            <Text>Company:</Text>
            <CustomInputField
              id='selectedCompany'
              type="select"
              value={ get(this.props, 'selectedCompany') }
              onChange={ (e) => this.props.handleInputLeaveHistory('company', e) }
            >
              { get(this.props, 'companys')
              && get(this.props, 'companys').map(g => {
                return <option key={ g._id } value={ g.name === 'Company' ? '' : g.name }>{ g.name }</option>
              })
              }
            </CustomInputField>
          </Col>
          <Col>
            <Text>LOB:</Text>
            <CustomInputField
              id='selectedLOB'
              type="select"
              value={ get(this.props, 'selectedLOB') }
              onChange={ (e) => this.props.handleInputLeaveHistory('lob', e) }
            >
              { get(this.props, 'lobs')
              && get(this.props, 'lobs').map(g => {
                return <option key={ g._id } value={ g.name === 'LOB' ? '' : g.name }>{ g.name }</option>
              })
              }
            </CustomInputField>
          </Col>
          <Col>
            <Text>Type:</Text>
            <CustomInputField
              id='selectedLeaveType'
              type="select"
              value={ get(this.props, 'selectedLeaveType') }
              onChange={ (e) => this.props.handleInputLeaveHistory('leave_type', e) }
            >
              { get(this.props, 'leave_types')
              && get(this.props, 'leave_types').map((g) => {
                return <option key={ g._id } value={ g.name === 'Leave Type' ? '' : g.name }>{ g.name }</option>
              })
              }
            </CustomInputField>
          </Col>
          <Col>
            <Text>Status:</Text>
            <CustomInputField
              id='selectedStatus'
              type="select"
              value={ get(this.props, 'selectedStatus') }
              onChange={ (e) => this.props.handleInputLeaveHistory('status', e) }
            >
              {
                leave_status.map((g) => {
                  return <option key={ g.value } value={ g.value }>{ g.label }</option>
                })
              }
            </CustomInputField>
          </Col>
        </WrapperButton>
        <CustomButton
          bg={ COLORS.UPLOAD_COLOR }
          border={ COLORS.UPLOAD_COLOR_BORDER }
          onClick={ this.props.export }
        >
          Export
        </CustomButton>
      </Wrapper>
    )
  }
}

SearchBarLeaveHistory.propTypes = {
  handleInputLeaveHistory: PropTypes.func,
  handleChangeStartDate: PropTypes.func,
  handleChangeEndDate: PropTypes.func,
  export: PropTypes.func,
}
SearchBarLeaveHistory.defaultProps = {
  handleInputLeaveHistory: () => {},
  handleChangeStartDate: () => {},
  handleChangeEndDate: () => {},
  export: () => {},
}

const Col = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
`
const WrapperButton = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1%;
  margin-right: 1%;
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-right: 10px;
  margin-top: 20px;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  position: relative;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const SearchField = styled.input`
  height: 30px;
  width: 200px;
  padding-left: 30px;
  margin-top: 20px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const Wrapper = styled.div`
  background-color: #ffffff;  
  height: 60px;
  position: relative;
  width: 100%;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const YOSDatePicker = styled(DatePicker)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  max-width: 100px;
  height: 30px;
  padding-left: 5%;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
  @media only screen and (max-width: 1440px) {
    width: 140px;
  }
  @media only screen and (max-width: 1024px) {
    width: 100px;
  }
`
const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  height: 30px;
`
const Text = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
`



// WEBPACK FOOTER //
// ./src/components/report/search-bar/leave-history.js